<svelte:options tag={null} />
  <script>
  export let id = undefined;
  export let style = undefined;
  export let className = undefined;
  export let fill = undefined;
  export let size = "2rem";
</script>

<svg aria-hidden="true" width={size} height={size} id={id}  style={style} class={className} fill={fill} xmlns="http://www.w3.org/2000/svg" viewBox="0 0 32 32"><path d="M25 20.16a1 1 0 00-1 1V25H8v-5.11l1.31 1.32a1 1 0 001.42 0 1 1 0 000-1.42l-3-3a1 1 0 00-1.42 0l-3 3a1 1 0 001.42 1.42L6 19.94V25a2 2 0 002 2h16a2 2 0 002-2v-3.84a1 1 0 00-1-1zM28.71 10.79a1 1 0 00-1.42 0L26 12.11V7a2 2 0 00-2-2H8a2 2 0 00-2 2v3.84a1 1 0 002 0V7h16v5.06l-1.27-1.27a1 1 0 00-1.42 1.42l3 3a1 1 0 001.42 0l3-3a1 1 0 00-.02-1.42z"/></svg>